/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = CloseIcon;
exports.LoadingIcon = LoadingIcon;
exports.ToggleIcon = ToggleIcon;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["size", "className", "svgProps"],
  _excluded2 = ["onClick", "className", "expanded", "size"],
  _excluded3 = ["size", "svgProps", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function CloseIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 10 : _ref$size,
    className = _ref.className,
    svgProps = _ref.svgProps,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: className
  }), _react.default.createElement("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
    width: size,
    height: size,
    viewBox: "0 0 10 10"
  }), _react.default.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeWidth: "1.33",
    d: "M1 1l8 8m0-8L1 9"
  })));
}
CloseIcon.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.number
};
function ToggleIcon(_ref2) {
  var onClick = _ref2.onClick,
    className = _ref2.className,
    expanded = _ref2.expanded,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 10 : _ref2$size,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: className,
    onClick: onClick
  }), _react.default.createElement("svg", {
    width: size,
    height: size / 2,
    viewBox: "0 0 10 5"
  }, expanded ? _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.262.262l4.106 4.106c.144.144.144.379 0 .524-.07.069-.164.108-.262.108H.894c-.204 0-.37-.166-.37-.37 0-.099.039-.193.108-.262L4.738.262c.145-.145.38-.145.524 0z"
  }) : _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.738 4.738L.632.632C.488.488.488.253.632.108.702.04.796 0 .894 0h8.212c.204 0 .37.166.37.37 0 .099-.039.193-.108.262L5.262 4.738c-.145.145-.38.145-.524 0z"
  })));
}
function LoadingIcon(_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 17 : _ref3$size,
    _ref3$svgProps = _ref3.svgProps,
    svgProps = _ref3$svgProps === void 0 ? {} : _ref3$svgProps,
    className = _ref3.className,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: className
  }), _react.default.createElement("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
    width: size,
    height: size,
    viewBox: "0 0 24 24"
  }), _react.default.createElement("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
  })));
}
LoadingIcon.propTypes = {
  size: _propTypes.default.number
};